import { Component, Input, Output, EventEmitter, ViewChildren, QueryList, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-verification-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './verification-modal.component.html',
  styleUrls: ['./verification-modal.component.scss']
})
export class VerificationModalComponent implements AfterViewInit, OnChanges {
  @Input() isOpen: boolean = false;
  @Input() phoneNumber: string = '';
  @Input() timer: number = 0;
  @Input() isCodeComplete: boolean = false;

  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<string[]>();
  @Output() keyDown = new EventEmitter<{ index: number, event: KeyboardEvent }>();

  @ViewChildren('codeInput') codeInputs!: QueryList<ElementRef>;

  code: string[] = ['', '', '', '', '', ''];

  ngAfterViewInit() {
    // Puedes manejar el focus aquí si lo necesitas
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen']) {
      console.log('isOpen changed:', this.isOpen);
      if (this.isOpen) {
        this.code = ['', '', '', '', '', ''];
        console.log('Inicializando code array (hijo):', this.code);
      }
    }
  }

  get isCodeCompleteLocal(): boolean {
    console.log('code array (hijo):', this.code);
    return this.code.every(d => d !== '');
  }

  onConfirm() {
    console.log('Confirmando código (hijo):', this.code);
    this.confirm.emit(this.code);
  }

  onKeyDown(index: number, event: KeyboardEvent) {
    this.keyDown.emit({ index, event });
  }
}